import React, {useEffect} from 'react';
import {useAppDispatch, useAppSelector} from "../../../../../../common/hook";
import {useParams} from "react-router-dom";
import {Preloader} from "components/layout/preloader/Preloader";
import {NothingYetMessage} from "../../../../personal-cabinet/nothing-yet-message/NothingYetMessage";
import {StudentsTestItem} from "./students-test-item/StudentsTestItem";
import {fetchTestStudentsById} from "features/model/service/test/fetch-test-students-by-id/fetchTestStudentsById";
import {StudentTest} from "features/model/types/test/studentTestById";
import {CustomPagination} from "components/pagination/CustomPagination";

export const StudentsTest = () => {
    const paginationData = useAppSelector((state) => state.testStudentsById.pagination);
    const studentsData = useAppSelector((state) => state.testStudentsById);
    const {tests, isLoading, error,pagination} = studentsData
    const {page, pageSize, pageCount} = paginationData;


    const dispatch = useAppDispatch();

    const {testId} = useParams();


    useEffect(() => {
        dispatch(fetchTestStudentsById({testId}));
    }, [dispatch, testId]);

    const onChangeHandle = (event: React.ChangeEvent<unknown>, value: number) => {
        dispatch(fetchTestStudentsById({testId,page: value - 1}));
    };




    return (
        <div className="tabs-content">
            <div className="tab">
                <div className="data-tbl inner-group-students-tbl">
                    <div className="row thead">
                        <div className="col student-col">Студент</div>
                        <div className="col status-col">Статус</div>
                        <div className="col lesson-time-col">Группа</div>
                        <div className="col current-level-col">Ответы</div>
                        <div className="col classes-attended-col align-right">Правильные ответы</div>
                    </div>


                    {isLoading ? (
                        <Preloader/>
                    ) : tests && tests.length > 0 ? (
                        tests.map((user: StudentTest) => (
                            <StudentsTestItem key={user.id} user={user}/>
                        ))
                    ) : (
                        <NothingYetMessage/>
                    )}

                    {pageCount > 1 && (
                        <CustomPagination pageCount={pageCount} onChangeHandle={onChangeHandle} />
                    )}
                </div>
            </div>
        </div>
    );
};

